module.exports = __webpack_public_path__ + "static/media/34.b0d63aea.png";